import { useQuery } from '@ts-core/lib/apollo';

import {
  getFillInTheBlanksExerciseQuery,
  GetFillInTheBlanksExerciseQueryResult,
  GetFillInTheBlanksExerciseQueryVariables,
} from '../graphql/queries/getFillInTheBlanksExerciseQuery';

import { FillInTheBlanksExercise } from '../types';

interface FillInTheBlanksExerciseInput {
  courseId: string;
  subjectId: string;
  exerciseId?: string;
}

interface FillInTheBlanksExerciseOutput {
  exercise?: FillInTheBlanksExercise;
  loading: boolean;
}

export default function useFillInTheBlanksExercise(input: FillInTheBlanksExerciseInput): FillInTheBlanksExerciseOutput {
  const { courseId, subjectId, exerciseId } = input;
  const { data, loading } = useQuery<GetFillInTheBlanksExerciseQueryResult, GetFillInTheBlanksExerciseQueryVariables>(
    getFillInTheBlanksExerciseQuery,
    {
      variables: {
        courseId,
        subjectId,
        exerciseId,
      },
      skip: !exerciseId,
    }
  );

  return {
    exercise: data?.fillInTheBlanksExercise,
    loading,
  };
}
